import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  articleData?: {
    publishedTime?: string;
    modifiedTime?: string;
    author?: string;
  };
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  articleData,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const linkEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (linkEl) {
      linkEl.href = canonicalUrl;
    } else {
      const newLink = document.createElement('link');
      newLink.rel = 'canonical';
      newLink.href = canonicalUrl;
      document.head.appendChild(newLink);
    }

    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    if (articleData?.publishedTime) {
      setMeta('article:published_time', articleData.publishedTime, true);
    }
    if (articleData?.modifiedTime) {
      setMeta('article:modified_time', articleData.modifiedTime, true);
    }
    if (articleData?.author) {
      setMeta('article:author', articleData.author, true);
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, articleData]);

  return null;
}